// export class RequestModel {
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
export class RequestModel {
  pageNumber :number;
  pageSize :number;
  filter : string
  orderBy : string;
  desc : string;
  companyId: string;
  fromCompanyId: string;
  countryId: number;  
  country: number;
  contactPersonId: string;
  name: string;
  senderId: string;
  receiverId: string;
  visitorId: number;
  longitude: number;
  latitude: number;
  visitorProfileId: string;
  serviceId: string;
  membershipType:string


  constructor() {
    this.pageNumber= 0;
    this.pageSize= 0;
    this.filter =""
    this.orderBy ="";
    this.desc ="";
    this.companyId ="";
    this.fromCompanyId = "";
    this.country = undefined;
    this.contactPersonId =""
    this.name ="";
    this.senderId="";
    this.receiverId="";
    this.visitorId=0;
    this.longitude=0;
    this.latitude=0;
    this.visitorProfileId="";
    this.serviceId = "";
    this.membershipType="";
  }
}